import { distinctUntilChanged, map, Observable } from 'rxjs';
import { i18nLocale$ } from 'streams/i18nLocale$';
import {
  ErrorInfoBoxLabels,
  getErrorInfoBoxLabels,
} from 'locales/getErrorInfoBoxLabels';

export const errorInfoBoxLabels$: Observable<ErrorInfoBoxLabels> =
  i18nLocale$.pipe(distinctUntilChanged(), map(getErrorInfoBoxLabels));
